import React, { useState } from "react";
import ModelViewer from "./components/ModelViewer";
import Circle from "./components/Circle";
import PageOne from "./components/PageOne";
import PageTwo from "./components/PageTwo";
import PageThree from "./components/PageThree";
import Header from "./components/Header";
import SideBySide from "./components/SideBySide";
import { Container, Row, Col } from "reactstrap";
import Logos from "./components/Logos";
import VideoPlayer from "./components/VideoPlayer";
import { Parallax, ParallaxLayer } from "react-spring/renderprops-addons";
import "./App.scss";

function App() {
  // return <h1 style={{ textAlign: "center" }}>mobile site under construction, please view on desktop</h1>;
  return (
    <div className="App">
      <Parallax pages={9.5} vertical>
        {/* 1 */}
        <ParallaxLayer offset={0.9} speed={0.4}>
          <div className="big-circle"></div>
        </ParallaxLayer>
        <ParallaxLayer offset={-0.2} speed={0.4}>
          <Circle width={"100vh"} height={"100vh"} left={"10%"}></Circle>
        </ParallaxLayer>

        <ParallaxLayer offset={0} speed={0.3}>
          <div id="header">
            <img className="lockup-img" src="/img/eli.png" alt="statue" />
            <img className="lockup" src="/img/lockup.svg" alt="hall of heroes" />
            <img className="lockup-arrow" src="/img/fold_arrow.svg" alt="arrow" />
          </div>
        </ParallaxLayer>

        <ParallaxLayer offset={0.9} speed={0}>
          <Circle width={"18vw"} height={"18vw"} left={"-10vw"} />
        </ParallaxLayer>

        <ParallaxLayer offset={1.5} speed={0.2}>
          <Circle width={"90vmin"} height={"90vmin"} left={"-20vmin"}></Circle>
        </ParallaxLayer>

        <ParallaxLayer offset={1.5} speed={0.1}>
          <div className="caleb"></div>
        </ParallaxLayer>

        <ParallaxLayer offset={2.4} speed={0.3}>
          <Circle width={40} height={40} left={"15vw"}></Circle>
        </ParallaxLayer>

        <ParallaxLayer offset={1} speed={0}>
          <Container fluid className="main-body-container">
            <Row>
              <Col xs="1" md="3"></Col>
              <Col xs="10" md="8">
                <h2>
                  Heroism in battle is traditionally celebrated with a statue. Every day, the staff at St. Jude
                  Children's Research Hospital witness extraordinary bravery from kids battling cancer and other
                  life-threatening diseases. But these inspiring kids have never been celebrated with statues.
                </h2>
              </Col>
              <Col xs="1" md="1"></Col>
            </Row>
          </Container>
        </ParallaxLayer>

        <ParallaxLayer offset={2.1} speed={0.01}>
          <img src="/img/quote.svg" className="quote" alt="quotation" />
        </ParallaxLayer>

        <ParallaxLayer offset={2.1} speed={0}>
          <Container fluid className="main-body-container">
            <Row>
              <Col xs="1" md="6"></Col>
              <Col xs="10" md="4">
                <h3>
                  No matter what she was going through, she just had this peace about her. I don’t think she was ever
                  afraid; if she was, she never let it on.
                </h3>
                <h4 style={{ textAlign: "right" }}>-Annika's Mom</h4>
              </Col>
              <Col xs="1" md="2"></Col>
            </Row>
          </Container>
        </ParallaxLayer>

        <ParallaxLayer offset={2.5} speed={0}>
          <Container fluid className="main-body-container">
            <Row>
              <Col xs="1" md="6"></Col>
              <Col xs="10" md="5">
                <h2>Now, thanks to virtual reality, we’ve done what isn’t possible in the real world.</h2>
              </Col>
              <Col xs="1" md="1"></Col>
            </Row>
          </Container>
        </ParallaxLayer>

        <ParallaxLayer offset={2.8} speed={0.1}>
          <div className="jazzy"></div>
        </ParallaxLayer>

        <ParallaxLayer offset={3.35} speed={0}>
          <Container fluid className="main-body-container">
            <Row className="offset-row">
              <Col xs="1" md="3"></Col>
              <Col xs="10" md="5">
                <h2>
                  Facebook and Oculus, guided by St. Jude, have transformed twelve brave patients into epic statues
                  fifty feet tall.
                </h2>
              </Col>
              <Col xs="1" md="4"></Col>
            </Row>
          </Container>
        </ParallaxLayer>

        <ParallaxLayer offset={3.75} speed={0}>
          <Container fluid className="main-body-container">
            <Row>
              <Col xs="1" md="2"></Col>
              <Col xs="10" md="5">
                <h2>
                  Each statue represents a story, a battle, a team, and at the center a young patient who fought for
                  their life.
                </h2>
              </Col>
              <Col xs="1" md="5"></Col>
            </Row>
          </Container>
        </ParallaxLayer>

        <ParallaxLayer offset={4.6} speed={0}>
          <Container fluid className="main-body-container">
            <Row>
              <Col xs="1" md="1"></Col>
              <Col xs="10" md="6">
                <h2>
                  You can visit them in the St. Jude Hall of Heroes VR app, where you can wander freely through the
                  statues, float up for a closer look, and hear the personal stories behind each one.
                </h2>
              </Col>
              <Col xs="1" md="5"></Col>
            </Row>
          </Container>
        </ParallaxLayer>

        <ParallaxLayer offset={4} speed={0.2}>
          <Circle width={"90vmin"} height={"90vmin"} left={"-30vmin"}></Circle>
        </ParallaxLayer>

        <ParallaxLayer offset={4} speed={0.1}>
          <div className="quincy"></div>
        </ParallaxLayer>

        {/* <ParallaxLayer offset={1} speed={0}>
          <ParallaxLayer offset={0.05} speed={0}>
            <Circle width={50} height={50} left={"25vw"}></Circle>
          </ParallaxLayer>

          <ParallaxLayer offset={0.8} speed={0}>
            <Circle width={50} height={50} left={"60vw"}></Circle>
          </ParallaxLayer>
         
          <ParallaxLayer offset={0}>
            <PageOne/>
          </ParallaxLayer>
        </ParallaxLayer> */}

        {/* <ParallaxLayer offset={2} speed={0}>
          <ParallaxLayer offset={0}>
            <PageTwo />
          </ParallaxLayer>
        </ParallaxLayer> */}

        {/* <ParallaxLayer offset={3} speed={0}>
          <ParallaxLayer offset={0}>
            <PageThree />
          </ParallaxLayer>
        </ParallaxLayer> */}

        <ParallaxLayer offset={5.25} speed={0}>
          {/* 3 */}
          <ModelViewer
            width={"100%"}
            height={600}
            options={[
              "Annika",
              "Caleb",
              "Chandler",
              "David",
              "Deuce",
              "Eli",
              "Jazzy",
              "Joel",
              "Madison",
              "Matthew",
              "Quincy",
              "Shaurya"
            ]}
            mobile
          />
        </ParallaxLayer>

        <ParallaxLayer offset={6.5} speed={0}>
          <VideoPlayer width={"100%"} height={"50%"} />
        </ParallaxLayer>
        <ParallaxLayer offset={7.1} speed={0}>
          <SideBySide
            orientation="left"
            headline="Experience it in Virtual Reality"
            paragraph="St. Jude Hall of Heroes will be available at select Best Buys starting December 6th through February 2nd, and will be available on Oculus TV to come February 2020."
            buttonText="Find a Store"
            imageUrl="/img/rift_s.png"
            alt="oculus rift"
            mobile
            showButton={true}
            link={"https://live.oculusvr.com/"}
          ></SideBySide>
        </ParallaxLayer>
        <ParallaxLayer offset={7.75} speed={0}>
          <SideBySide
            orientation="right"
            headline="About St. Jude"
            paragraph="St. Jude won't stop until no child dies of cancer. Click the link below to find out more about St. Jude and how you can help."
            buttonText="Learn More &amp; Donate"
            imageUrl="/img/sj_logo.svg"
            alt="St Jude Childrens Research Hospital"
            mobile
            showButton={true}
            link={"https://www.stjude.org/get-involved/other-ways/hall-of-heroes-vr.html"}
          ></SideBySide>
        </ParallaxLayer>

        <ParallaxLayer offset={8.4} speed={0}>
          <SideBySide
            orientation="right"
            headline="Bring the statues into the real world"
            paragraph="There’s also a Facebook and Instagram AR lens. Using your phone, you can place your favorite statue wherever you like, pose with it, and share it. Use #hallofheroes so we can see too. "
            buttonText="Try it out on Instagram"
            imageUrl="/img/ar_img_mobile.png"
            alt="St Jude Childrens Research Hospital"
            mobile
            showButton={true}
            link={"https://www.instagram.com/a/r/?effect_id=436530200573650"}
          ></SideBySide>
        </ParallaxLayer>

        <ParallaxLayer offset={9.25} speed={0}>
          <Logos />
        </ParallaxLayer>
      </Parallax>
    </div>
  );
  // }
}

export default App;
